import BaseCarousel from "./BaseCarousel";
import {translate} from "../../utils";
import IPItem from "./IPItem";

export default class IPCarousel extends BaseCarousel {
    constructor(startIndex) {
        super(startIndex);
        //this.hide();
    }

    init(data) {
        for (let i = 0; i < data.length; i++) {
            const item = new IPItem(data[i]);
            this._itemHolder.addChild(item);
            this._items.push(item);
        }

        this._setItemPositions();

        this.selected.logo.visible = true;
    }

    reveal() {
        this._nextButton.visible = true;
        this._prevButton.visible = true;
        this._selectButton.visible = true;
        this._interaction.interactive = true;
    }

    hide() {
        this._nextButton.visible = false;
        this._prevButton.visible = false;
        this._selectButton.visible = false;
        this._interaction.interactive = false;
    }

    _setItemPositions() {
        super._setItemPositions();
    }

    next() {
        if (this._animating || this._selectionMade)
            return;

        this.selected.logo.visible = false;

        super.next();

        this.selected.logo.visible = true;
    }

    prev() {
        if (this._animating || this._selectionMade)
            return;

        this.selected.logo.visible = false;

        super.prev();

        this.selected.logo.visible = true;
    }
}